import { render, staticRenderFns } from "./EditPriceOfferForm.vue?vue&type=template&id=01fa45e6"
import script from "./EditPriceOfferForm.vue?vue&type=script&lang=js"
export * from "./EditPriceOfferForm.vue?vue&type=script&lang=js"
import style0 from "./EditPriceOfferForm.vue?vue&type=style&index=0&id=01fa45e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports